import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { NotificationsService } from "angular2-notifications";
import { GenericService } from "./generic.service";
import { apiCallWrapper } from "../api/api.util";
import { ClientDocumentApi, IApiResponse } from "../api/client-document.api";
import { IClientDocument } from "../model/client-document.model";

@Injectable()
export class ClientDocumentService extends GenericService<IClientDocument> {
  constructor(
    public api: ClientDocumentApi,
    public notifications: NotificationsService
  ) {
    super(api, notifications);
  }

  public clientDocumentListing(payload: {
    clientId: string;
    search?: string;
    tag?: string;
  }): Observable<IApiResponse<IClientDocument[]>> {
    return this.api.clientDocumentListing(payload);
  }

  public upload(formData: FormData): Observable<IApiResponse<IClientDocument>> {
    return this.api.upload(formData);
  }

  public getDownloadUrl(id: string): Observable<IApiResponse<{ url: string }>> {
    return this.api.getDownloadUrl(id);
  }

  public deleteDocument(id: string): Observable<any> {
    return apiCallWrapper(
      this.api.deleteDocument(id),
      {
        notificationsService: this.notifications,
        action: `Deleting client document ${id}`
      }
    );
  }
}

